import { render } from "./OrderSummary.vue?vue&type=template&id=8e2a7aac&scoped=true&ts=true"
import script from "./OrderSummary.vue?vue&type=script&lang=ts"
export * from "./OrderSummary.vue?vue&type=script&lang=ts"

import "./OrderSummary.vue?vue&type=style&index=0&id=8e2a7aac&lang=sass&scoped=true"
import "./OrderSummary.vue?vue&type=style&index=1&id=8e2a7aac&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e2a7aac"]])

export default __exports__